// src/components/ForgotPasswordModal.jsx
import React, { useState } from "react";

export default function ForgotPasswordModal({ open, onClose, onReset }) {
  const [email, setEmail] = useState("");

  if (!open) return null;

  return (
    <div className="fp-overlay">
      <div className="fp-modal glass-card">

        <h2 className="fp-title">Reset Password</h2>
        <p className="fp-sub">
          Enter your email and we’ll send you a reset link.
        </p>

        <input
          type="email"
          className="fp-input"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* BUTTON ROW */}
        <div className="fp-buttons">
          <button
            className="landing-primary-btn"
            onClick={() => onReset(email)}
          >
            Send Reset Email
          </button>

          <button className="fp-close" onClick={onClose}>
            Close
          </button>
        </div>

      </div>
    </div>
  );
}
